<ng-container *ngIf="{canEdit: canAdministerLicense()} as permission">
	<div *ngIf="isLoading(); else holdersTable" class="license-holder-loading">
		<i class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
	</div>

	<ng-template #holdersTable>
		<table class="license-holder-table">
			<thead>
				<tr>
					<th class="cell-with-padding-left" translate="license-management_licensed-users"></th>
					<th class="license-permission-th" translate="license-management_permissions"></th>
					<th translate="license-management_date-invited"></th>
					<th translate="license-management-date-accepted"></th>
					<th>
						{{ 'license-management_seat-used' | translate}}
						<span
							[matTooltip]="'license-management_instructor-seat-used-tooltip' | translate"
							class="ficon-help">
						</span>
					</th>
					<th class="action-cell"></th>
				</tr>
			</thead>

			<tbody>
				<tr *ngFor="let holder of $any(holdersAndInvites())">
					<td class="cell-with-padding-left">
						<span *ngIf="holder.user">
							<span *ngIf="auth.isAdmin()">
								{{ holder.user.user_id }} &#8212;
							</span>
							{{ holder.user.first_name }} {{ holder.user.last_name }}
						</span>
						<span class="user-email text-secondary">
							(<span *ngIf="holder.user">{{ holder.user.email }}</span>
							<span *ngIf="!holder.user">{{ holder.email }}</span
							>)
						</span>
					</td>
					<td>
						<mat-form-field class="license-holder-permission" subscriptSizing="dynamic">
							<mat-select [value]="holder.is_admin" (selectionChange)="permissionChange($event, holder)" [disabled]="!canUpdateHolder(holder) || !permission.canEdit">
							  <mat-option [value]="true">
								{{ 'license-management_permissions-admin' | translate}}
							  </mat-option>
							  <mat-option [value]="false">
								{{ 'license-management_permissions-instructor' | translate }}
							  </mat-option>
							</mat-select>
							<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
						</mat-form-field>
					</td>
					<td>
						<span *ngIf="holder.invite">
							{{ holder.invite.created_at | date: 'short':'UTC' }}
						</span>
						<span *ngIf="!holder.invite">
							{{ holder.created_at | date: 'short':'UTC' }}
						</span>
					</td>
					<td>
						<span *ngIf="holder.user">
							{{ holder.created_at | date: 'short':'UTC' }}
						</span>
					</td>
					<td>
						<button type="button"
							*ngIf="permission.canEdit"
							class="view-seats-lnk goreact-btn link-btn"
							(click)="viewSeats(holder)">
							{{holder.seats_consumed}}
						</button>
						<div *ngIf="!permission.canEdit">{{holder.seats_consumed}}</div>
					</td>
					<td class="action-cell">
						<button
							mat-button
							*ngIf="canRemoveHolder(holder) && permission.canEdit"
							(click)="removeUser(holder)"
							[disabled]="$any(holder).removing">
							<i class="ficon-app-x" *ngIf="!$any(holder).removing"></i>
							<i class="ficon-spinner ficon-spin" *ngIf="$any(holder).removing"></i>
						</button>
					</td>
				</tr>
			</tbody>

			<tfoot *ngIf="permission.canEdit">
				<tr>
					<td colspan="6">
						<button mat-flat-button class="goreact-btn secondary-btn" (click)="addUsers()">
							<mat-icon class="ficon-add"></mat-icon>
							<span translate="license-management_add-user"></span>
						</button>
					</td>
				</tr>
			</tfoot>
		</table>

		@if (paginationMeta(); as meta) {
			<mat-paginator
				class="license-holder-paginator"
				[length]="meta.total"
				[pageIndex]="pageIndex()"
				[pageSize]="meta.per_page || pageSize"
				[pageSizeOptions]="[meta.per_page || pageSize]"
				[hidePageSize]="true"
				[showFirstLastButtons]="true"
				(page)="onPageChange($event)">
			</mat-paginator>
		}
	</ng-template>
</ng-container>
